module.exports = __webpack_public_path__ + "img/logoRecuperacao.53ad161f.png";